var map = {
	"./demos/basic/index.ts": 99352,
	"./demos/disabled/index.ts": 19618,
	"./demos/ghost/index.ts": 73663,
	"./demos/group/index.ts": 66265,
	"./demos/icon/index.ts": 74507,
	"./demos/loading/index.ts": 74932,
	"./demos/size/index.ts": 17186,
	"./demos/tagName/index.ts": 1761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46782;